import React, { Component } from "react";
import Modal from "@acadia-ui/modal";
import moment from "moment";
import Button from "@acadia-ui/button";
import Loading from "../../Components/LoadingSpinner";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";
import FormBuilderV2 from "../../Components/FormBuilder/FormBuilderV2";
import UpdateStateHelper from "../../Components/FormBuilder/UpdateStateHelper";
import ModalHelpers from "./ModalHelpers";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import PlacementDataStore from "../../Flux/Stores/PlacementDataStore";
import { updateSheetDataArray } from "../../Flux/Actions/PlacementActions";
import { ToastNotification, showToast, TOAST_TYPE } from "@acadia-ui/toast";
import "./modal.scss";

const initialState = {
	formData: {},
	postData: {},
	errors: {},
	showErrors: false,
	valueToCalculate: null,
	isFormDataValid: false,
	isFormTouched: false
};

const formEl = "edit_placement";

class EditPlacement extends Component {
	constructor(props) {
		super(props);
		this.state = {
			metaData: {
				StartDate: moment(this.props.metaData.StartDate).format("YYYY/MM/DD"),
				EndDate: moment(this.props.metaData.EndDate).format("YYYY/MM/DD")
			},
			loading: false,
			...initialState
		};
	}

	componentDidMount() {
		this.props.editPlacement?.(this);
		PlacementDataStore.on("error_placement", this.handleErrors);
		PlacementDataStore.on("placement__errors__reset", this.handleReset);
		PlacementDataStore.on("placement_success", this.handleSuccess);
	}

	componentDidUpdate() {
		this.isValidFormData();
	}

	componentWillUnmount() {
		this.props.editPlacement?.(undefined);
		PlacementDataStore.removeListener("error_placement", this.handleErrors);
		PlacementDataStore.removeListener("placement__errors__reset", this.handleReset);
		PlacementDataStore.removeListener("placement_success", this.handleSuccess);
	}

	updateModalState = () => {
		this.setState({ open: !this.state.open, ...initialState });
	};

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		if (this.state.loading === false) {
			ModalHelpers.openClose(event, this.updateModalState, this.state, initialState, () => {
				ErrorHelpers.resetErrors(formEl);
				if (!this.state.open) {
					const modals = document.getElementsByClassName("bx--modal-content");
					if (this.props.config) {
						const fieldCount =
							(this.props.config.PlacementData || []).filter((field) => field.FieldType !== "Hidden").length +
							(this.props.config.TaxonomyData || []).filter((field) => field.FieldType !== "Hidden").length +
							(this.props.config.MetaData || []).filter((field) => field.FieldType !== "Hidden").length;
						if (modals) {
							if (fieldCount <= 8) {
								for (const modal of modals) {
									if (modal.style.overflow !== "visible") {
										modal.style.overflow = "visible";
									}
								}
							} else {
								for (const modal of modals) {
									if (modal.style.overflow !== "auto") {
										modal.style.overflow = "auto";
									}
								}
							}
						}
					}

					this.setState({ loading: true }, () => {
						this.fillFields();
					});
				}
			});
		}
	};
	/* END */

	fillFields = () => {
		if (this.props.placementData) {
			const postData = { PlacementData: { PlacementID: this.props.placementData.PlacementID } };
			// Include PlatformPlacementPK for Prisma edits if available
			try {
				if (this.props.placementData.PlatformPlacementPK) {
					const parsed = JSON.parse(this.props.placementData.PlatformPlacementPK);
					const prisma = parsed?.find?.(({ MasterPlatformID }) => MasterPlatformID == 5);
					if (prisma?.PlatformPK) {
						postData.PlatformPlacementPK = prisma.PlatformPK;
					}
				}
			} catch (e) {}

			// Preserve parent relation for non-standalone
			let packageData = {};
			if (this.props.placementData.PackageID) {
				packageData = { ParentUniqueIdCode: this.props.placementData.PackageID, packageType: this.props.placementData.PlacementParentPackageType };
				postData.ParentData = packageData;
			}

			// prefill the valueToCalculate

			const vtcMap = {
				PlannedUnits: "PlannedUnits",
				Rate: "unitRate",
				Cost: "plannedTotalCost"
			};
			const vtc =
				vtcMap?.[
					this.props?.config?.PlacementData?.filter?.((field) => ["Rate", "Cost", "PlannedUnits"]?.includes(field.Name) && field.FieldType === "Calculated")?.[0]?.Name
				] || null;

			this.setState({ postData, packageData, loading: false, valueToCalculate: vtc }, () => {
				this.matchData();
			});
		}
	};

	matchData = () => {
		this.handleReset();
		const configObjs = Object.entries(this.props.config);
		const dataFieldsArray = [];
		const row = this.props.placementData || {};
		const enableRates = !row.PackageID || row.PlacementParentPackageType === "Programmatic"; // standalone OR programmatic child

		console.log({ row });

		for (const dataBucket of configObjs) {
			if (dataBucket[0] !== "ChildData") {
				for (const field of dataBucket[1]) {
					if (row.hasOwnProperty(field.Name)) {
						if (field.DataType === "Select") {
							let optionID = row[`${field.Name}ID`];
							let fieldLabel = row[field.Name];
							const fieldItem = dataBucket[1].filter((a) => a.Name == field.Name);
							if (fieldItem.length > 0) {
								const optionItem = fieldItem[0].Options.filter((a) => a.OptionLabel == row[field.Name]);
								if (optionItem.length > 0) {
									optionID = optionItem[0].OptionID;
								}
							}

							if (optionID === undefined) {
								let dataValueID = null;
								const previousTaxonomyData = row.TaxonomyData && row.TaxonomyData !== "" ? JSON.parse(row.TaxonomyData) : [];
								const previousMetaData = row.MetaData && row.MetaData !== "" ? JSON.parse(row.MetaData) : [];
								previousTaxonomyData.forEach((taxonomyField) => {
									if (taxonomyField.DataKeyShortDescr === field.Label) {
										if (taxonomyField.DataValue) {
											dataValueID = taxonomyField.DataValue.DataValueID;
										}
									}
								});
								if (dataValueID === null) {
									previousMetaData.forEach((metaDataField) => {
										if (metaDataField.DataKeyShortDescr === field.Label) {
											if (metaDataField.DataValue) {
												dataValueID = metaDataField.DataValue.DataValueID;
											}
										}
									});
								}
								if (dataValueID !== null) {
									const changedMatchingOption = field.Options.filter((option) => option.OptionID === dataValueID.toString());
									if (changedMatchingOption[0] !== undefined) {
										optionID = changedMatchingOption[0].OptionID;
										fieldLabel = changedMatchingOption[0].OptionLabel;
									}
								}
							}

							let disabled = false;

							if (["RateType"].includes(field.Name)) {
								disabled = !enableRates && row.PlacementParentPackageType !== "Programmatic";
							}

							// https://techjira.publicis.com/browse/ACTMASTER-5084
							// Disable InNameSite for all child placements NOT of type search order and standalone
							if (field.Name === "InNameSite" && row.PackageID && row.PackageType !== "SearchOrder") {
								disabled = true;
							}

							// https://techjira.publicis.com/browse/ACTMASTER-5085
							// Disable Rate Type and Buy Type for Search Order placement type
							if (["RateType", "BuyType"].includes(field.Name) && row.PackageType === "SearchOrder") {
								disabled = true;
							}

							if (optionID != undefined && optionID > 0) {
								dataFieldsArray.push([dataBucket[0], field.Name, { value: optionID, label: fieldLabel }, field.ID, field.DataType, false, disabled]);
							}
						} else {
							let disabled = false;
							if (["Rate", "PlannedUnits", "Cost"].includes(field.Name)) {
								disabled = !enableRates;
							}
							dataFieldsArray.push([dataBucket[0], field.Name, row[field.Name], field.ID, field.DataType, false, disabled]);
						}
					}
				}
			}
		}
		// Disable ParentDescription in edit
		if (row.ParentDescription) {
			dataFieldsArray.push([
				"ParentData",
				"ParentDescription",
				{ label: row.ParentDescription, value: row.PackageID, packageType: row.PlacementParentPackageType },
				null,
				"Select",
				false,
				true
			]);
		}

		setTimeout(() => {
			console.log({ dataFieldsArray });
			this.updateStatev2(dataFieldsArray);
		}, 100);
	};

	isValidFormData = () => {
		const { formData } = this.state;
		const row = this.props.placementData || {};
		const isStandalone = !row.PackageID;
		const isProgrammatic = row.PlacementParentPackageType === "Programmatic";
		let isValid = true;
		for (const key in formData) {
			if (Object.hasOwn(formData, key)) {
				const { value } = formData[key];
				const isDisabled = formData[key].disabled;
				if (
					["Rate", "Cost", "PlannedUnits"].includes(key) &&
					(["Flat", "Free", "Added Value"].includes(formData.RateType?.value?.label) || (!isStandalone && !isProgrammatic))
				) {
					if ((value === "" || value == null || value == undefined) && !isDisabled) {
						isValid = false;
					}
				} else if ((value == "" || value == null || value == undefined || value == "0.00") && !isDisabled) {
					isValid = false;
				}
			}
		}

		if (this.state.isFormDataValid !== isValid) {
			this.setState({ isFormDataValid: isValid });
		}
	};

	updateState = (dataConfig, name, value, id, dataType, calc, disabled) => {
		if (this.state.loading === false) {
			this.setState({ isFormTouched: true });
			UpdateStateHelper.update(dataConfig, name, value, id, dataType, calc, formEl, this, disabled, this.props.config, false, this.isValidFormData);
		}
	};

	updateStatev2 = (dataFieldsArray) => {
		if (this.state.loading === false) {
			UpdateStateHelper.updatev2(dataFieldsArray, formEl, this, this.props.config);
		}
	};

	handleReset = () => {
		ErrorHelpers.resetErrors(formEl);
	};

	sortTaxonomyData = (taxonomyData) => {
		const taxDataWithPositions = taxonomyData;
		taxDataWithPositions.forEach((taxonomyField) => {
			if (this.props.config.TaxonomyData) {
				this.props.config.TaxonomyData.forEach((taxFieldConfig) => {
					if (taxFieldConfig.ID === taxonomyField.dataKeyID) {
						taxonomyField.Position = taxFieldConfig.Position;
					}
				});
			}
		});
		taxDataWithPositions.sort((a, b) => {
			if (a.Position < b.Position) {
				return -1;
			}
			if (a.Position > b.Position) {
				return 1;
			}
			return 0;
		});
		taxDataWithPositions.forEach((taxonomyField) => {
			delete taxonomyField.Position;
		});
		return taxDataWithPositions;
	};

	formDataObjForPost = (newRowObj) => {
		if (Object.keys(newRowObj).length > 0) {
			const postData = { ...this.state.postData };
			let strippedTaxonomyPostData = [];

			for (const i in postData.TaxonomyData) {
				strippedTaxonomyPostData.push(postData.TaxonomyData[i]);
			}
			strippedTaxonomyPostData = this.sortTaxonomyData(strippedTaxonomyPostData);
			const strippedMetadataPostData = [];
			for (const i in postData.MetaData) {
				strippedMetadataPostData.push(postData.MetaData[i]);
			}
			postData.MetaData = strippedMetadataPostData;
			postData.TaxonomyData = strippedTaxonomyPostData;

			const filters = BookFiltersStore.getChoicesState();
			const campaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();

			if (!postData.PlacementData) {
				postData.PlacementData = {};
			}
			postData.PlacementData.MasterCampaignID = this.props.metaData.MasterCampaignID;
			postData.PlacementData.CampaignID = this.props.metaData.CampaignUniqueIDCode;
			if (this.props.metaData.Budget === null || this.props.metaData.Budget === 0) {
				postData.PlacementData.Cost = 0;
			}

			if (postData.ParentData) {
				if (this.state.formData.ParentDescription) {
					if (this.state.formData.ParentDescription.value.label === "STANDALONE" && this.state.formData.ParentDescription.value.value === "STANDALONE") {
						delete postData.ParentData;
					}
				}
			}

			if (this.state.formData?.ParentDescription?.value?.label === "Search Order" && this.state.formData?.ParentDescription?.value?.value === "Search Order") {
				delete postData.ParentData;
				postData.PlacementData.PackageType = "Search Order";
			}

			const PlatformID = filters.platform.value;
			const AuditLevelID = this.props.auditLevelID;
			const contextValues = BookFiltersStore.getContextValues();
			const formSubmissionObj = {
				MasterAgencyDivisionName: contextValues?.agency?.name,
				MasterBusinessUnitName: contextValues?.client?.name,
				MasterCountryCode: contextValues?.country?.name,
				ContextID: contextValues.contextId,
				PlatformID,
				AuditLevelID,
				MasterRegionCode: contextValues?.region?.name,
				CampaignUniqueIDCode: campaignUniqueID,
				...postData
			};
			return formSubmissionObj;
		}
		this.setState({ errors: { Errors: ["Please fill in all form fields."] }, showErrors: true }, () => {
			ErrorHelpers.displayErrors(formEl, this.state.errors);
		});
	};

	sendPostObject = (newRowObj) => {
		this.postObject = this.formDataObjForPost(newRowObj);
		if (this.postObject) {
			updateSheetDataArray([this.postObject]);
		}
		if (this.postObject === undefined) {
			this.setState({ loading: false });
		}
	};

	handleSubmit = (e) => {
		if (this.state.loading === false) {
			this.setState({ loading: true }, () => {
				// e.preventDefault();
				this.sendPostObject(this.state.formData);
			});
		}
	};

	handleSuccess = () => {
		if (this.state.open) {
			this.setState({ loading: false }, () => {
				this.triggerOpenClose();
				this.props.refresh?.();
			});
			this.props.updateCounts?.("Placement");
			this.props.updateMetaData?.();
			showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Placement updated successfully." timed={5000} />);
		}
	};

	handleErrors = () => {
		this.setState({ loading: false }, () => {
			const errors = PlacementDataStore.getErrors();
			if (Object.keys(errors).length > 0) {
				this.setState({ errors, showErrors: true }, () => {
					const type = "edit placement";
					ErrorHelpers.displayErrors(formEl, this.state.errors, type);
					showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.ERROR} message="Placement could not be updated." />);
				});
			}
		});
	};

	enableSubmit = () => {
		if (this.state.isFormTouched && this.state.isFormDataValid === true) {
			return false;
		}
		return true;
	};

	updateCalculatedField = (value) => {
		this.setState({ valueToCalculate: value });
	};

	render() {
		const isDisabled = this.state.loading ? "disabledModal" : "";
		let formInnards = null;
		if (this.props.config && Object.keys(this.props.config).length !== 0) {
			formInnards = (
				<FormBuilderV2
					type="edit placement"
					data={this.props.config}
					configName="EditPlacement"
					onUpdate={this.updateState}
					state={this.state}
					rerenderDP={true}
					updateCalculatedField={this.updateCalculatedField}
					formEl={formEl}
					parentRef={this}
					metaData={this.props.metaData}
					auditLevelID={this.props.auditLevelID}
					syncStatus={this.props.placementData?.ExternalSystemStatusID}
				/>
			);
		}

		return (
			<>
				<Modal
					id={formEl}
					className={`edit--placement ${isDisabled}`}
					heading="Edit Placement"
					description="You can make edits inline, then click the 'Save' button to save the changes."
					isOpen={this.state.open}
					onRequestClose={() => {
						if (this.state.open) {
							this.triggerOpenClose();
						}
					}}
					size="medium"
					userClosable={true}
					onClick={() => {}}
					actionSetProps={{
						actionsRight: (
							<>
								<Button className="first-button" display="secondary" onClick={this.triggerOpenClose} data-tracking-id-alt="cancel-edit-placement">
									Cancel
								</Button>
								<Button
									className="third-button"
									display="primary"
									disabled={this.enableSubmit()}
									onClick={this.handleSubmit}
									data-tracking-id-alt="confirm-edit-placement"
								>
									Save
								</Button>
							</>
						)
					}}
				>
					{this.state.loading ? (
						<Loading className="modalLoading" />
					) : (
						<form autoComplete="off">
							<div className="form__group__container _m-t--10 _m-b--10">{formInnards}</div>
							{this.state.showErrors && <div id="errors__container" />}
						</form>
					)}
				</Modal>
			</>
		);
	}
}

export default EditPlacement;
